import styled from "styled-components";
import { ButtonGroup as MuiButtonGroup } from "@material-ui/core";

export const ButtonGroup = styled(MuiButtonGroup)`
    padding-bottom: 5px;
`;

export default ButtonGroup;
